import React from 'react';

import Select from 'react-select';

import { useGetQuery } from 'api/useGetQuery';
import { ENDPOINTS } from 'api/endpoints';
import { Asset } from 'types/Asset';
import { useState } from 'react';
import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import { FixedSizeList } from 'react-window';

const height = 35;

const MenuList = (props: any) => {
  const { options, children, maxHeight, getValue } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * height;

  return (
    <FixedSizeList
      width="100%"
      height={maxHeight}
      itemCount={children.length}
      itemSize={height}
      initialScrollOffset={initialOffset}>
      {({ index, style }: any) => <div style={style}>{children[index]}</div>}
    </FixedSizeList>
  );
};

type Props = {
  // eslint-disable-next-line no-unused-vars
  onAddAsset: (asset: Asset) => void;
  firmNamePropertyDefinitionId?: number | null;
  productNamePropertyDefinitionId?: number | null;
  resourceIdsToExclude: (number | null | undefined)[];
  productUploadAssetIdsToExclude?: (string | null | undefined)[];
  show: boolean;
};

type LookupResult = {
  id: number;
  name: string;
};

const AssetLookup: React.FC<Props> = ({
  onAddAsset,
  firmNamePropertyDefinitionId,
  productNamePropertyDefinitionId,
  resourceIdsToExclude,
  productUploadAssetIdsToExclude,
  show,
}: Props) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selected, setSelected] = useState<boolean>(false);

  const styles = {
    control: (base: any) => ({
      ...base,
      minHeight: null,
    }),
    menu: (base: any) => ({
      ...base,
      fontSize: '80%',
    }),
  };

  const [dataEnvironment] = useDataEnvironment();
  const { isLoading, data } = useGetQuery<LookupResult[]>(
    ENDPOINTS.assetSearch(
      dataEnvironment!.id,
      searchTerm,
      firmNamePropertyDefinitionId && firmNamePropertyDefinitionId > 0
        ? firmNamePropertyDefinitionId
        : '',
      productNamePropertyDefinitionId && productNamePropertyDefinitionId > 0
        ? productNamePropertyDefinitionId
        : '',
    ),
  );

  const displayData = data
    ? data
        .filter(
          (asset: any) =>
            !productUploadAssetIdsToExclude?.includes(asset.productUploadAssetId) &&
            !resourceIdsToExclude?.includes(asset.resourceId),
        )
        .map((asset: any) => ({ value: asset, label: asset.name }))
    : [];

  return (
    <div
      className="form-group mt-2"
      style={{ zIndex: 99999, marginBottom: 0, display: show ? 'block' : 'none' }}>
      <Select
        options={displayData}
        onChange={(asset: any) => {
          setSearchTerm('');
          setSelected(!selected);
          onAddAsset(asset.value);
        }}
        isLoading={isLoading}
        isClearable={false}
        onInputChange={setSearchTerm}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        menuPlacement="top"
        components={{
          MenuList,
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
          IndicatorsContainer: () => null,
        }}
        styles={styles}
        value={selected ? null : null}
        placeholder="Add an asset..."
      />
    </div>
  );
};

export default AssetLookup;
